import { generateClassName, getColorScheme } from '@klv/shared/utils/functions';

import * as s from './styles/quote.module.css';

import type { IQuoteProps } from './types';

const Quote = (
  { attribution = '', quote, backgroundColor, ...props }: IQuoteProps,
) => {
  const { className } = props;

  return (
    <figure
      className={generateClassName([s.quoteFigure, className])}
      data-color-scheme={getColorScheme(backgroundColor)}
    >
      <blockquote className={generateClassName([s.quoteText, 'p2'])}>
        {quote}
      </blockquote>
      <figcaption className={generateClassName([s.quoteAttribution, 'tagline'])}>
        {attribution}
      </figcaption>
    </figure>
  );
};

export default Quote;
